<section class="menu-card">
  <article>
    <img
      loading="lazy"
      src="assets/rush/5K-gold-coins-in-pot.png"
      alt="Table illustration"
      class="h-[64x] w-[64px] self-center"
    />
    <div class="details">
      <div class="title">{{ table.name }}</div>
      <div class="pot">
        <div class="amount">POT : {{ table.potBonus | number: '0.0-2' }}</div>
      </div>
      <div class="tags">
        <div class="normal">
          <div class="label">{{ table.buyInCost | number: '0.0-2' }} Coins Buy In</div>
        </div>
        <div class="normal">
          <div class="label">{{ table.foldCost | number: '0.0-2' }} Fold</div>
        </div>
        <div class="normal">
          <div class="label">
            {{ table.minBet | number: '0.0-2' }} - {{ table.maxBet | number: '0.0-2' }} Bet
          </div>
        </div>
        <div class="normal">
          <div class="label">5 Seats</div>
        </div>
      </div>
    </div>
    <button class="btn-play" (click)="goToGameRoom()">
      <img
        loading="lazy"
        src="assets/rush/svg/icon-play.svg"
        alt="play"
        class="h-[16x] w-[16px] self-center"
      />
      <span class="text-[12px]">PLAY</span>
    </button>
  </article>
</section>
